import * as React from 'react';
import {connect} from 'react-redux';
import {Card} from "antd";
import {DraftPeople} from '@models/draftPeople';
import TableRenderer from "@hocs/TableRenderer";
import DraftsPeopleTable from "@components/draftsPeople/Table";
import {fetchRequest, updateRequest} from '@actions/draftPeople';
import SearchDraftsPeopleComponent from "@components/draftsPeople/Search";
import {ApplicationState, ConnectedReduxProps} from '@reducers/index';

interface PropsFromState {
    loading: boolean
    data: DraftPeople[]
    errors?: string,
    count: number
}

interface PropsFromDispatch {
    fetchRequest: typeof fetchRequest,
    updateRequest: typeof updateRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps

class DraftsPeopleIndexPage extends React.Component<AllProps> {
    render() {
        const {loading, data, search, currentPage, updateRequest} = this.props;
        return (
            <div className={'page-table-wrapper'}>
                <Card className={`page-table-header search-part`} bordered={false}>
                    <SearchDraftsPeopleComponent search={search}/>
                </Card>
                <DraftsPeopleTable data={data}
                                   currentPage={currentPage}
                                   rowKey={record => record.id}
                                   updateRequest={updateRequest}
                                   loading={loading}/>
            </div>
        )
    }
}

const mapStateToProps = ({draftsPeople}: ApplicationState) => ({
    loading: draftsPeople.loading,
    errors: draftsPeople.errors,
    data: draftsPeople.data,
    count: draftsPeople.count
});

const mapDispatchToProps = {
    fetchRequest,
    updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(DraftsPeopleIndexPage));

